import { TABLE_TOKENS } from "components/tables/styles";

const styles = {
    // btn: {
    //     background: `linear-gradient(30.99deg,#4527A0 0%, #673AB7 100%)`,
    //     font: 'normal normal 500 16px/18px Roboto',
    //     padding: '0 20px',
    //     '&.MuiButtonBase-root': {
    //         '&:disabled': {
    //             background: '#F3F3F3',
    //             color: 'rgba(24, 27, 32, 0.87) !important',
    //             backdropFilter: 'blur(20px)',
    //         },
    //     },
    // },
    btn: {
        height: "36px",
        minWidth: "auto",
        px: 2.25,
        mr: 1,
        borderRadius: "10px",
        textTransform: "none",
        fontFamily: TABLE_TOKENS.font,
        fontWeight: 600,
        fontSize: "0.875rem",
        letterSpacing: "0.01em",
        boxShadow: "none",
        background: `linear-gradient(135deg, ${TABLE_TOKENS.accent} 0%, ${TABLE_TOKENS.accentMuted} 100%)`,
        "&:hover": {
            boxShadow: "0 4px 12px rgba(85, 70, 255, 0.28)",
            background: `linear-gradient(135deg, ${TABLE_TOKENS.accentMuted} 0%, ${TABLE_TOKENS.accent} 100%)`,
        },
    }
};
export default styles;
